// extracted by mini-css-extract-plugin
export default {"pdf-document":"ZlwOF","viewer":"j7MFW","placeholder":"vCKkX"};